import React from "react";
import { V19Page } from "./V19Page";
export default function Analytics() {
  return <V19Page view="analytics" testid="analytics-view" />;
}
